import React from "react";

import { MediaEmbedBlock as MediaEmbedBlockValue } from "@reactivated";

import { EmbedBlock } from "../EmbedBlock";

export const MediaEmbedBlock = (props: {
    value: MediaEmbedBlockValue;
    className?: string | null;
}) => {
    if (!props.value.embed) {
        return null;
    }
    return <EmbedBlock value={props.value.embed} className={props.className} />;
};
